import { handleActions } from 'redux-actions'
import { setAccordionPage } from './actions'

export const initialState = {
    activities: { currentPage: 1 },
    notes: { currentPage: 1 },
}

export default handleActions(
    {
        [setAccordionPage]: (state, { payload: { domain, page } }) => ({
            ...state,
            [domain]: { currentPage: page },
        }),
    },
    initialState
)
